<template>
  <LMap
    :zoom="11"
    :center="center"
    :zoomControl="true"
    :scrollWheelZoom="true"
    :doubleClickZoom="true"
    style="height: 500px; width: 100%;"
  >
    <LTileLayer
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      attribution="&copy; OpenStreetMap contributors"
    />
    <LMarker
      v-for="canteen in visibleCanteens"
      :key="`canteen-${canteen.id}`"
      :icon="customIcon"
      :lat-lng="canteen.coords"
    >
      <!-- <LTooltip>
        {{ canteen.name }}
      </LTooltip> -->
      <LPopup class="pa-0 ma-0">
        <router-link
          :to="{
            name: 'CanteenPage',
            params: { canteenUrlComponent: $store.getters.getCanteenUrlComponent(canteen) },
          }"
        >
          {{ canteen.name }}
        </router-link>
        <p>{{ canteen.address }}, {{ canteen.postal_code }} {{ canteen.city }}</p>
      </LPopup>
    </LMarker>
  </LMap>
</template>

<script>
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet"
import L from "leaflet"

const customIcon = new L.Icon({
  iconUrl: "/static/icons/pin.svg",
  iconSize: [32, 32],
  iconAnchor: [16, 32],
})

export default {
  name: "CanteenMap",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
  data() {
    return {
      visibleCanteens: null,
      customIcon: customIcon,
      center: [43.599998, 1.43333], // coordonnées de Toulouse pour centrer la map
    }
  },
  methods: {
    fetchCurrentPage() {
      const url = "/api/v1/publishedCanteens"

      return fetch(url)
        .then((response) => {
          if (response.status < 200 || response.status >= 400) throw new Error(`Error encountered : ${response}`)
          return response.json()
        })
        .then(async (response) => {
          let canteens = response.results
          for (const canteen of canteens) {
            const coords = await this.getLatLng(canteen.address + ", " + canteen.city)
            canteen.coords = coords
          }
          this.visibleCanteens = canteens
        })
        .catch((e) => {
          this.$store.dispatch("notifyServerError", e)
        })
    },
    async getLatLng(address) {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`
      )
      const data = await response.json()

      if (data.length > 0) {
        return [parseFloat(data[0].lat), parseFloat(data[0].lon)]
      } else {
        console.log("Adresse introuvable !")
      }
    },
  },
  mounted() {
    this.fetchCurrentPage()
  },
}
</script>
